import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Vectors/logo.png";
import { useTranslation } from "../../i18n/LanguageContext";
import "./style.css";

const navLinks = [
    { to: "/About", key: "nav.about" },
    { to: "/Volunteers", key: "nav.volunteers" },
    { to: "/Organizations", key: "nav.organizations" },
    { to: "/Events", key: "nav.events" },
    { to: "/BecomePartner", key: "nav.becomePartner" },
];

const legalLinks = [
    { to: "/TermsOfUse", key: "legal.terms" },
    { to: "/PrivacyPolicy", key: "legal.privacy" },
    { to: "/VolunteerAgreement", key: "legal.agreement" },
    { to: "/Feedback", key: "legal.feedback" },
];

const socialLinks = [
    { label: "Instagram", href: "#" },
    { label: "Telegram", href: "#" },
    { label: "WhatsApp", href: "#" },
    { label: "TikTok", href: "#" },
    { label: "Facebook", href: "#" },
];

const Footer = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <div className={`footerBackground ${isHome ? "footer--light" : "footer--brand"}`}>
            <footer className="footer">
                <div className="footer-content">
                    <div className="footerMain">
                        <div className="footer-brand">
                            <Link to="/" aria-label="CtrlEvents — գլխավոր">
                                <img src={logo} alt="CtrlEvents" />
                            </Link>
                            <p>{t("footer.tagline")}</p>
                        </div>

                        <nav className="footer-col" aria-label="Էջեր">
                            <h3>{t("footer.col.platform")}</h3>
                            <ul>
                                {navLinks.map((l) => (
                                    <li key={l.to}>
                                        <Link to={l.to}>{t(l.key)}</Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        <nav className="footer-col" aria-label="Իրավական">
                            <h3>{t("footer.col.legal")}</h3>
                            <ul>
                                {legalLinks.map((l) => (
                                    <li key={l.to}>
                                        <Link to={l.to}>{t(l.key)}</Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        <nav className="footer-col" aria-label="Սոցիալական ցանցեր">
                            <h3>{t("footer.col.social")}</h3>
                            <ul>
                                {socialLinks.map((l) => (
                                    <li key={l.label}>
                                        <a
                                            href={l.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>

                    <p className="copyRightText">
                        © {new Date().getFullYear()} {t("footer.copyright")}
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
